export default {
  existing_documents: {
    description:
      'U heeft de volgende documenten al geüpload. Selecteer een document en klik op verzenden, of upload een nieuw document.',
    sides: {
      front: 'Voorkant',
      back: 'Achterkant',
    },
    created_at: 'Geüpload: {{date}}',
    expires_at: 'Vervalt: {{date}}',
  },
  document_types: {
    owner_document: 'Identiteitsdocument eigenaar',
    business_document: 'Bedrijfsdocument',
  },
  form: {
    document_type: {
      label: 'Bewijs van bedrijfsdocument',
      placeholder: 'Selecteer documenttype',
      options: {
        vat_registration: 'BTW-registratie',
        trade_registration: 'Handelsregistratie',
        trade_license: 'Handelsvergunning',
        commercial_register_extract: 'Uittreksel handelsregister',
        financial_statements: 'Financiële overzichten',
        other: 'Overige',
      },
    },
    front: {
      label: 'Voorkant document',
    },
    back: {
      label: 'Achterkant document (optioneel voor sommige documenten)',
    },
    expires_at: {
      label: 'Vervaldatum document',
      placeholder: 'Selecteer vervaldatum',
    },
  },
  buttons: {
    select_file: 'Bestand selecteren',
    next: 'Volgende',
    back: 'Achterkant',
    send: 'Verzenden',
    upload_new: 'Nieuw document uploaden',
    use_existing: 'Een geüpload document gebruiken',
  },
};
